import { useParams, useHistory } from "react-router";
import { DataStore } from '@aws-amplify/datastore';
import { Account, Transaction } from '../models';
import { useState, useEffect } from 'react';
import AccountDetails from "../components/Accounts/AccountDetails";
import { Button } from 'react-bootstrap';
import { withAuthenticator } from "@aws-amplify/ui-react";

const initialState = { username: '', currency: 'USD', balance: 0.00, Transactions: []};

const AccountWithdrawal = ( { user, setShow, setText }) => {
    const { id } = useParams();
    const history = useHistory();
    const [account, setAccount] = useState(initialState);
    const [formState, setFormState] = useState({amount: 0});
    useEffect(() => {
      let mounted = true;
      async function fetchAccount() {
        try {
          const account = await DataStore.query(Account, c => c.id("eq", id));
          return account;
        } catch (err) {
          console.log('error fetching items');
          return [];
        }
      }
      fetchAccount().then((account) => {
        if(mounted){
          setAccount(account);
        }
      })
      return () => { mounted = false }
    }, [id]);
    const updateAccount = async () => {
      try {
          const original = await DataStore.query(Account, id);
          await DataStore.save(
              Account.copyOf(original, updated => {
                  updated.username = user
                  updated.currency = original.currency
                  updated.balance = original.balance - formState.amount
              })
          ).then((account) => {
            createTransaction(account);
          })
      } catch (err) {
          console.log(err)
      }
    }

  function setInput(key, value) {
    let v = value;
    console.log(v, account[0].balance)
    if(key === 'amount'){
      v = Number(value);
    }
    if(v > account[0].balance){
      document.getElementById("withdrawButton").disabled = true;
      document.getElementById("inputAmount").textContent = account[0].balance;
    } else {
      document.getElementById("withdrawButton").disabled = false;
      setFormState({ ...formState, [key]: v });
    }
  }

  async function createTransaction(account) {
  try {
    const transaction = await DataStore.save(new Transaction({
        accountID: account.id,
        username: account.username,
        action: `Withdrew: ${formState.amount} - ${account.currency}`
    }));
    setText("Withdrawal Successful!");
    setShow(true)
    setTimeout(() => {
      history.push("/");
    }, 2000);
    return (transaction, account);
  } catch (err) {
    console.log('error updating store items:', err);
  }
}
    return (
        <div className="home">
         <AccountDetails account={ account[0] }/>
         <div className="form">
          <h2>Withdraw Funds</h2>
          <label>Amount</label>
          <input
            type='number'
            onChange={event => setInput('amount', event.target.value)}
            value={formState.amount}
            min=".001"
            step=".001"
            id="inputAmount"
          />
          <Button onClick={ updateAccount } id="withdrawButton">Withdraw</Button>
          </div>
        </div>
        )
    }
 
export default withAuthenticator(AccountWithdrawal);